import script from "./oasis-sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./oasis-sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./oasis-sidebar.vue?vue&type=style&index=0&id=1e69110d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e69110d"]])

export default __exports__